import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getMachine, updateMachine } from 'slice/machineSlice';
import { deleteRequest } from 'apis/ApiInstence';
import AdminTable from 'common/AdminTable';
import TruncatedMessage from 'common/TruncatedMessage';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

const MachineList = () => {
    const dispatch = useDispatch();
    const machineData = useSelector((state) => state.machine);
    const [showModal, setShowModal] = useState(false);
    const [currentMachine, setCurrentMachine] = useState(null);
    const [imageFile, setImageFile] = useState(null);

    useEffect(() => {
        dispatch(getMachine());
    }, [dispatch]);

    const handleEditClick = (machine) => {
        setCurrentMachine(machine);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentMachine(null);
        setImageFile(null);
    };

    const handleSave = () => {
        const formData = new FormData();
        formData.append('name', currentMachine.name);
        formData.append('description', currentMachine.description);
        formData.append('is_active', currentMachine.is_active);
        formData.append('price', currentMachine?.price);
        formData.append('unit', currentMachine?.unit);
        formData.append('stock_quantity', currentMachine?.stock_quantity);

        if (imageFile) {
            formData.append('image', imageFile);
        }
        dispatch(updateMachine({ id: currentMachine.id, data: formData }));
        toast('Machine Updated Successfully!')
        handleCloseModal();
    };

    const handleRemove = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                await deleteRequest(`machine/${id}`);
                dispatch(getMachine());
                Swal.fire("Deleted!", "The machine has been removed.", "success");
            }
        });
    };

    const handleImageChange = (event) => {
        setImageFile(event.target.files[0]);
    };

    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Image',
            accessor: 'image',
            Cell: ({ row }) => (
                <img
                    src={`${process.env.REACT_APP_BACKEND}asserts/machine/${row.original.images}`}
                    alt={row.original.name}
                    width={100}
                />
            ),
        },
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            Header: 'Unit',
            accessor: 'unit',
        },
        {
            Header: 'Price',
            accessor: 'price',
        },
        {
            Header: 'Stock Qty',
            accessor: 'stock_quantity',
        },
        {
            Header: 'Created Date',
            accessor: 'createdAt',
        },
        {
            Header: 'Description',
            accessor: 'description',
            Cell: ({ row }) => <TruncatedMessage text={row.original.description} maxLength={30} />
        },
        {
            Header: 'Active',
            accessor: 'is_active',
            Cell: ({ row }) => (
                <span className={row.original.is_active ? 'badge badge-success' : 'badge badge-danger'}>
                    {row.original.is_active ? 'Active' : 'Inactive'}
                </span>
            ),
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <>
                    <button
                        className="btn removebtn mx-1 my-1"
                        onClick={() => handleRemove(row.original.id)}
                    >
                        Remove
                    </button>
                    <button
                        className="btn editbtn mx-1 my-1"
                        onClick={() => handleEditClick(row.original)}
                    >
                        Edit
                    </button>
                </>
            ),
        },
    ];

    return (
        <>
            <div className="container-fluid mt-5 ">
                <div className="mainheadig mx-4">
                    <h4 className="text-white font-weight-bold">Machine List</h4>
                </div>
                {machineData?.data?.length > 0 && (
                    <AdminTable tableHeaders={tableHeaders} tableData={machineData.data} />
                )}
            </div>

            {showModal && currentMachine && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-labelledby="editModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="editModalLabel">Edit Machine</h5>
                                <button type="button" className="close" onClick={handleCloseModal} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="form-group">
                                        <label htmlFor="machineStatus">Status</label>
                                        <select defaultValue={currentMachine.is_active} onChange={(e) => setCurrentMachine({ ...currentMachine, is_active: e.target.value })} className="form-control" id="machineStatus">
                                            <option value={true}>Active</option>
                                            <option value={false}>Inactive</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="machineName">Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="machineName"
                                            value={currentMachine.name}
                                            onChange={(e) => setCurrentMachine({ ...currentMachine, name: e.target.value })}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="machinePrice">Price</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="machinePrice"
                                            value={currentMachine.price}
                                            onChange={(e) => setCurrentMachine({ ...currentMachine, price: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="machineUnit">Unit</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="machineUnit"
                                            value={currentMachine.unit}
                                            onChange={(e) => setCurrentMachine({ ...currentMachine, unit: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="machineStock">Stock Quantity</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="machineStock"
                                            value={currentMachine.stock_quantity}
                                            onChange={(e) => setCurrentMachine({ ...currentMachine, stock_quantity: e.target.value })}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="machineDescription">Description</label>
                                        <textarea
                                            className="form-control"
                                            id="machineDescription"
                                            value={currentMachine.description}
                                            onChange={(e) => setCurrentMachine({ ...currentMachine, description: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="updateImage">Update Image</label>
                                        <input type='file' name='image' className='form-control' onChange={(e) => handleImageChange(e)} />
                                        {
                                            imageFile && (
                                                <img src={URL.createObjectURL(imageFile)} alt='machine' className='img-fluid' />
                                            )
                                        }
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Close</button>
                                <button type="button" className="btn btn-primary" onClick={handleSave}>Save changes</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default MachineList;
